import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  showCloseButton: false
} satisfies RecursivePartial<DialogConfig['productDetailCard']>
